export const featureFlags = {
  authCodeConfigurationActive:
    process.env.REACT_APP_FEATURE_AUTH_CODE_CONFIGURATION === 'true',
  newCSharpFlowsActive:
    process.env.REACT_APP_FEATURE_CREATE_CSHARP_FLOWS === 'true',
};
